import React from "react";
import "./css/TermsAndConditionPage.css";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";

import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";

function TermsAndConditionsPage() {

  return (
    <div className="kopvillkor-container">
      <div
        className="kopvillkor-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <ToHomeBtn />
      <div className="kopvillkor-content-wrapper">
        <div className="kopvillkor-image-container">
          <img 
            src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?fm=jpg&q=80&w=1000" 
            alt="Köpvillkor" 
            className="kopvillkor-image"
          />
        </div>
        <div className="kopvillkor-card">
          <h2>Köpvillkor</h2>
          <p>This will be the terms and conditions page</p>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default TermsAndConditionsPage;
